<template>
    <div class="container">
        <div class='intro'>
            尊敬的快影用户（以下简称“您”），快手科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们希望通过本《隐私权保护政策（摘要）》帮助您直观、简明地了解我们如何收集、使用您的个人信息，以及如何保护您的个人信息。您可查阅<span style='color:rgba(110, 175, 204, 1)'>《隐私权保护政策》</span>了解完整内容。
        </div>
        <div class='subTitle'>一、为提供服务收集使用的个人信息</div>
        <div class='itemTitle'>1.用户注册及登录</div>
        <div class='itemInfo'>手机号码、第三方账号（如快手、微信、QQ等）、您在快手的关注用户列表信息</div>
        <div class='itemTitle'>2. 用户基本信息</div>
        <div class='itemInfo'>头像、昵称</div>
        <div class='itemTitle'>3. 音视频、图片文字等内容剪辑服务</div>
        <div class='itemInfo'>设备信息、设备所在位置、个人上网记录、面部像素信息、发布的模板信息</div>
        <div class='itemTitle'>4. 社交类活动</div>
        <div class='itemInfo'>粉丝、关注、快手好友、喜欢的模板、喜欢的教程、收藏的内容，剪切板中的口令、分享码、链接及相册中分享或被分享的视频和图片</div>
        <div class='itemTitle'>5. 营销活动</div>
        <div class='itemInfo'>姓名、电话号码、联系地址及联系方式、银行账号或第三方支付账号信息</div>
        <div class='itemTitle'>6. 安全保障</div>
        <div class='itemInfo'>注册信息、设备信息、网络设备硬件地址(MAC)、唯一设备标识符、网络日志，以及您安装的应用信息、正在运行的进程信息、应用程序</div>
        <div class='btn' @click="openUrl(urlList.userInfoTable)" >查看详细《个人信息收集清单》</div>
        <div class='subTitle'>二、为提供服务申请使用的权限</div>
        <div class='itemTitle'>1.存储权限</div>
        <div class='itemInfo'>读取/存储用户信息、日志信息、媒体文件</div>
        <div class='itemTitle'>2. 摄像头、闪光灯、麦克风、相册权限</div>
        <div class='itemInfo'>拍摄、录音、编辑、制作、上传、发布、分享音视图文，扫描二维码</div>
        <div class='itemTitle'>3. 通知权限</div>
        <div class='itemInfo'>推送照片、视频等编辑功能及美化服务和资源</div>
        <div class='itemTitle'>4. 位置权限</div>
        <div class='itemInfo'>制作内容以及发布时需要申请所在的位置信息权限</div>
        <div class='itemTitle'>5. 震动权限</div>
        <div class='itemInfo'>音乐高潮点</div>
        <div class='itemTitle'>6. 日历权限</div>
        <div class='itemInfo'>“提醒”或者“签到”的服务功能发生日时通过系统信息通知</div>
        <div class='itemTitle'>7. 手机状态码权限</div>
        <div class='itemInfo'>安卓系统崩溃情况下，查看后台日志信息排查问题</div>
        <div class='itemTitle'>8. 传感器权限</div>
        <div class='itemInfo'>iOS客户端使用拍摄功能时，需要判断手机当前处于横屏或是竖屏以提供更好的服务</div>
        <div class='itemTitle'>9. 剪切板权限</div>
        <div class='itemInfo'>分享或接收被分享的信息、参加活动等情形下，以实现跳转、分享、活动联动等功能或服务，打开分享或活动的内容</div>
        <div class='btn' @click="openSysAuthor()">查看详细《权限列表》</div>
        <div class='subTitle'>三、向第三方共享信息</div>
        <div class='itemInfo'>仅为实现隐私权保护政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供，我们会与合作伙伴共享您的某些个人信息。我们将遵守法律规定，仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们会与合作伙伴签署严格的数据保护协议，要求其按照我们数据隐私保护的措施与要求来处理个人信息。如果我们共享您的个人敏感信息或授权合作伙伴改变个人信息的使用及处理目的，将再次征求您的授权同意。</div>
        <div class='btn' @click="openUrl(urlList.sdk)">查看《第三方数据合作清单》</div>
        <div class='subTitle'>四、个人信息权益保障</div>
        <div class='itemInfo'>我们通过以下措施努力保障您的隐私体验：</div>
        <div class='itemTitle'>1. 访问、更正、删除您的个人信息：</div>
        <div class='itemInfo'>您可在快影客户端应用程序中通过【我的-点击您的头像】，在“个人资料”页面，进行查看、更正、删除您的账户名称、头像、个人资料等账户信息。</div>
        <div class='itemTitle'>2. 下载您的个人信息</div>
        <div class='itemInfo'>您可在快影客户端应用程序中通过【我的-设置-编辑资料-点击右上角icon-个人信息下载】，下载自己的个人信息文件。</div>
        <div class='itemTitle'>3. 管理、撤回您的授权同意：</div>
        <div class='itemInfo'>您可通过快手客户端应用程序中【设置-帐号与安全-授权管理-快影-解除授权】的方式撤回关注用户列表信息的授权；可在快影客户端应用程序中通过【我的-设置】退出登录，或者使用移动终端设备功能或应用权限管理中撤回或管理您的授权。</div>
        <div class='itemTitle'>4. 注销账号</div>
        <div class='itemInfo'>您可在快影客户端应用程序中通过【我的-设置-编辑资料】向快影申请账户的注销。</div>
        <div class='subTitle'>五、联系我们</div>
        <div class='itemInfo'>如果您对本隐私权保护政策、个人信息安全及未成年人个人信息保护相关事宜有任何疑问、投诉、意见或建议，您可以将您的问题发送至<span style='color:rgba(110, 175, 204, 1)'>kuaiying@kuaishou.com</span>与我们联系。</div>
        <div class='itemInfo'>快影联系地址：北京市海淀区上地西路6号1幢1层101D1-10，联系方式<span style='color:rgba(110, 175, 204, 1)'>400-126-0088</span>。</div>
        <div class='itemInfo'>快影将尽快审核所涉问题，并在验证您的用户身份后及时予以回复。一般情况下，我们将在48小时内回复您的请求。</div>
        <div class='btn' @click="openUrl(urlList.privacy)">查看隐私权保护政策完整版</div>
    </div>
</template>
<script>
import { openAuthority } from '../utils/action'
export default {
    name: "Summary",
    components: {
    },
    data(){
        return {
            urlList:{
                userInfoTable:'https://kuaiying-h5-csr-userinfo.webdev.test.gifshow.com/userInfoTable/index.html#/index',
                privacy:'https://ky.kuaishou.com/protocol/privacy-v1/CN',
                sdk:'https://kmovie.webdev.test.gifshow.com/protocol/sdk-ios'
            }
        }
    },
    created() {
        document.title = '隐私权保护政策摘要'
    },
    methods:{
        openUrl(url){
            location.href = url
        },
        openSysAuthor(){
            openAuthority()
        }
    }
};
</script>

<style lang="less" scoped>
.container{
    background: #141414;
    min-height: 100vh;
    width: '100%';
    padding: 0.6rem  0.4rem;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 400;
    font-size: 0.26rem;
    text-align: justify;
    font-family: 'PingFang SC';
    font-style: normal;
    .intro{
        margin-bottom: 0.72rem;
    }
    .subTitle{
        margin-bottom: 0.32rem;
        font-weight: 600;
        font-size: 0.34rem;
        color: rgba(255, 255, 255, 0.9);
    }
    .itemTitle{
        font-weight: 600;
        font-size: 0.28rem;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.9);
        margin-bottom: 0.08rem;
    }
    .itemInfo{
        margin-bottom: 0.3rem;
    }
    .btn{
        margin: 0.7rem auto 1.28rem auto;
        width: 5.28rem;
        height: 1.04rem;
        border: 0.02px solid rgba(255, 255, 255, 0.08);
        border-radius: 0.52rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.3rem;
        color: rgba(255, 255, 255, 0.9);
    }
}
</style>
